import { Space, Radio, Checkbox, Flex, Typography } from "antd";
import dayjs from "dayjs";

export default function QuestionOptionPreview(props) {
	const { data } = props;

	const RenderSub = () => {
		if (data.sub_answer || data.sub_sub_answer) {
			return (
				<>
					{data.sub_answer && (
						<Typography.Text strong className="sub-answer">
							{typeof data.sub_answer === "string"
								? data.sub_answer
								: JSON.stringify(data.sub_answer)}
						</Typography.Text>
					)}
					{data.sub_sub_answer && (
						<>
							<Typography.Text strong className="sub-answer">
								{": "}
								{data.sub_sub_answer}
							</Typography.Text>
						</>
					)}
				</>
			);
		}

		return null;
	};

	if (data && data.question_type === "Text (Input)") {
		return <div className="options">{data.answer ? data.answer : ""}</div>;
	} else if (data && data.question_type === "Text (Open Answer)") {
		return (
			<div className="options">
				{data.answer
					? JSON.parse(data.answer).map((item, index) => (
							<Flex vertical="vertical" key={index}>
								<Flex gap={5}>
									<span>{index + 1}.</span>
									<span>{item}</span>
								</Flex>
							</Flex>
					  ))
					: ""}
			</div>
		);
	} else if (data && data.question_type === "Number (Input)") {
		return <div className="options"> {data.answer ? data.answer : ""}</div>;
	} else if (data && data.question_type === "Radio (Button)") {
		return (
			<div className="options">
				<Radio.Group size="large" value={data.answer} disabled>
					<Space direction="vertical">
						{data.form_question_options
							? data.form_question_options.map((item, index) => {
									return (
										<Radio key={index} value={item.option}>
											{item.option}
										</Radio>
									);
							  })
							: ""}
					</Space>
				</Radio.Group>

				{RenderSub()}
			</div>
		);
	} else if (data && data.question_type === "Checkbox") {
		return (
			<div className="options">
				<Checkbox.Group size="large" disabled value={data.answer}>
					<Space direction="vertical">
						{data.form_question_options
							? data.form_question_options.map((item, index) => {
									return (
										<Checkbox key={index} value={item.option}>
											{item.option}
										</Checkbox>
									);
							  })
							: ""}
					</Space>
				</Checkbox.Group>

				{RenderSub()}
			</div>
		);
	} else if (data && data.question_type === "Select (Dropdown)") {
		return (
			<div className="options">
				{data.answer ? data.answer : ""}
				{RenderSub()}
			</div>
		);
	} else if (data && data.question_type === "Date (Datepicker)") {
		return (
			<div className="options">
				{data.answer ? dayjs(data.answer).format("MM/DD/YYYY") : ""}
			</div>
		);
	} else {
		return null;
	}
}
